import { GET_LIST, GET_MANY } from "react-admin";

import { getApiUrlForResource } from '../services/apiUrlResolver';

// Helper function to get API URL at request time
const getApiUrl = () => getApiUrlForResource('insurancePlans'); // Using camelCase for flag mapping

export const INSURANCE_PLANS_RESOURCE_NAME = "insurance-plans";

const providerRequestToHttpRequest = (requestType) => {
    switch (requestType) {
        case GET_LIST:
        case GET_MANY: {
            return {
                url: `${getApiUrl()}/${INSURANCE_PLANS_RESOURCE_NAME}`,
            };
        }
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

const httpResponseToProviderData = (
  httpResponse,
  requestType,
  requestParams
) => {
    let { json } = httpResponse;
    switch (requestType) {
        case GET_LIST:
            return {
                data: json.map(template => template),
                total: json.length,
            };
        case GET_MANY:
            let healthieInsuranceIds = requestParams.ids;

            return {
                data: json.filter(templateId => healthieInsuranceIds.includes(Number(templateId.id))),
                total: json.length,
            };
        default:
            return {
                data: json,
                total: json.length,
            };
    }
};

export default {
    resource: INSURANCE_PLANS_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData,
    },
};
